import { I18n } from '@calendly/i18n'
import { useState } from 'react'

import { Buffers as BuffersField } from 'components/event_type_edit'

import { AddButton } from '../../../components'
import { useDebouncedFormContext } from '../../hooks'
import {
  PanelContentContainer,
  PanelContentHeader,
  PanelContentSubtitle,
  PanelContentTitle,
  PanelContentValueLocked
} from '../styles'

const BuffersLocked = () => (
  <PanelContentContainer section>
    <PanelContentHeader isLocked>
      <PanelContentTitle>
        {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.buffer_times')}
      </PanelContentTitle>
      <PanelContentValueLocked>
        <BuffersField isLocked />
      </PanelContentValueLocked>
    </PanelContentHeader>
    <PanelContentSubtitle>
      {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.buffer_times_description')}
    </PanelContentSubtitle>
  </PanelContentContainer>
)

const BuffersSection = () => {
  const { values: { beforeBuffer, afterBuffer } } = useDebouncedFormContext()
  const isBufferTimeSet = Number(beforeBuffer) || Number(afterBuffer)
  const [isBufferTimeOpen, setIsBufferTimeOpen] = useState(isBufferTimeSet)

  return (
    <PanelContentContainer section data-testid="buffers_section">
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.buffer_times')}
        </PanelContentTitle>
        <PanelContentSubtitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.buffer_times_description')}
        </PanelContentSubtitle>
      </PanelContentHeader>
      {!isBufferTimeOpen ? (
        <AddButton onClick={() => setIsBufferTimeOpen(true)}>
          {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.set_buffer_time')}
        </AddButton>
      ) : (
        <PanelContentContainer subsection>
          <BuffersField />
        </PanelContentContainer>
      )}
    </PanelContentContainer>
  )
}

export const Buffers = ({ isLocked }) => (
  !isLocked ? <BuffersSection /> : <BuffersLocked />
)
